import { Button } from "@travellocal/ui";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

const PlanYourTrip = ({
  styles,
  country,
  requestUrl,
}: {
  styles: { [key: string]: string };
  country: string;
  requestUrl: string;
}) => {
  const { t } = useTranslation();
  return (
    <div
      className={classNames(
        styles.planYourTrip,
        "columns is-centered has-text-centered"
      )}
    >
      <div className={classNames(styles.planYourTripColumn, "column is-6 is-4-widescreen is-12-mobile mb-7")}>
        <hr className={styles.horizontalBreak} />
        <h4 className={styles.planYourTripHeading}>
          {t(
            "web:CountryPage_PlanYourTrip_heading",
            "Your {{country}} trip, just the way you like it",
            { country }
          )}
        </h4>
        <p className={styles.planYourTripParagraph}>
          {t(
            "web:CountryPage_PlanYourTrip_paragraph",
            "Our local experts in {{country}} are ready to help plan your perfect itinerary. Tailor-made, made easy.",
            { country }
          )}
        </p>
        <Button
          className={styles.planYourTripCtaButton}
          element="link"
          colour="teal"
          href={requestUrl}
          target="_self"
        >
          {t("web:CountryPage_PlanYourTrip_ctaText", "Plan your trip")}
        </Button>
      </div>
    </div>
  );
};

export default PlanYourTrip;
